import { render, staticRenderFns } from "./editions-schedule.vue?vue&type=template&id=c9ff0920"
import script from "./editions-schedule.vue?vue&type=script&lang=js"
export * from "./editions-schedule.vue?vue&type=script&lang=js"
import style0 from "./editions-schedule.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports